const initState = {
  professions: [],
  successFetching: false,
  errorFetching: false,
};

export default initState;
